import { render, staticRenderFns } from "./NavCoupon.vue?vue&type=template&id=c68e3bf0&scoped=true"
import script from "./NavCoupon.vue?vue&type=script&lang=js"
export * from "./NavCoupon.vue?vue&type=script&lang=js"
import style0 from "./NavCoupon.vue?vue&type=style&index=0&id=c68e3bf0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68e3bf0",
  null
  
)

export default component.exports